import getLocalString from "constants/Localization";
import { useGetReportJobCostByProductTypeMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportJobCostByProductType = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportJobCostByProductTypeMutation();
  const [getReportJobCostByProductType, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportJobCostByProductType",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportJobCostByProductType, { ...context, data }] as const;
};

export default useGetReportJobCostByProductType;
